import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "w-full flex gap-2 overflow-x-auto scroll-smooth" };
const _hoisted_2 = {
    key: 1,
    class: "flex-none inline-flex items-center gap-2 bg-neutral text-badge px-3 py-2 rounded-[4px] text-sm font-medium"
};
const _hoisted_3 = {
    key: 3,
    class: "flex-none inline-flex items-center gap-2 bg-neutral text-badge px-3 py-2 rounded-[4px] text-sm font-medium"
};
const _hoisted_4 = {
    key: 4,
    class: "flex-none inline-flex items-center gap-2 bg-neutral text-badge px-3 py-2 rounded-[4px] text-sm font-medium"
};
const _hoisted_5 = {
    key: 5,
    class: "flex-none inline-flex items-center gap-2 bg-neutral text-badge px-3 py-2 rounded-[4px] text-sm font-medium"
};
const _hoisted_6 = {
    key: 6,
    class: "flex-none inline-flex items-center gap-2 bg-neutral text-badge px-3 py-2 rounded-[4px] text-sm font-medium"
};
const _hoisted_7 = {
    key: 7,
    class: "text-badge/50 text-sm italic"
};
import { computed } from 'vue';
import { useHomeFilterStore } from './homeFilterStore';
import { X } from 'lucide-vue-next';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-filter-dialog-selected-filter',
    setup(__props) {
        const homeFilterStore = useHomeFilterStore();
        const clearAllBrands = () => {
            // Clear all selected brands
            homeFilterStore.selectedBrands.forEach(brand => {
                homeFilterStore.toggleBrandSelection(brand.id);
            });
        };
        const clearAllConditions = () => {
            // Clear all selected conditions
            homeFilterStore.selectedConditions.forEach(condition => {
                homeFilterStore.toggleConditionSelection(condition.id);
            });
        };
        const clearPriceFilter = () => {
            // Clear price filter
            homeFilterStore.minPrice = 0;
            homeFilterStore.maxPrice = 0;
        };
        const clearYearFilter = () => {
            // Clear year filter
            homeFilterStore.minYear = '';
            homeFilterStore.maxYear = '';
        };
        const clearSizeFilter = () => {
            homeFilterStore.minSizeDiameter = 0;
            homeFilterStore.maxSizeDiameter = 0;
        };
        const brandSummary = computed(() => {
            const selectedBrands = homeFilterStore.selectedBrands;
            if (selectedBrands.length === 0) {
                return '';
            }
            if (selectedBrands.length >= 4) {
                return `Brand(${selectedBrands.length})`;
            }
            // For less than 4 brands, list them with commas
            return selectedBrands.map(brand => brand.name).join(', ');
        });
        const conditionSummary = computed(() => {
            const selectedConditions = homeFilterStore.selectedConditions;
            if (selectedConditions.length === 0) {
                return '';
            }
            if (selectedConditions.length >= 4) {
                return `Condition(${selectedConditions.length})`;
            }
            // For less than 4 conditions, list them with commas
            return selectedConditions.map(condition => condition.name).join(', ');
        });
        const priceSummary = computed(() => {
            const minPrice = homeFilterStore.minPrice;
            const maxPrice = homeFilterStore.maxPrice;
            if (minPrice === 0 && maxPrice === 0) {
                return '';
            }
            if (minPrice > 0 && maxPrice > 0) {
                return `$${minPrice.toLocaleString()} - $${maxPrice.toLocaleString()}`;
            }
            if (minPrice > 0) {
                return `From $${minPrice.toLocaleString()}`;
            }
            if (maxPrice > 0) {
                return `Up to $${maxPrice.toLocaleString()}`;
            }
            return '';
        });
        const hasPriceFilter = computed(() => {
            return homeFilterStore.minPrice > 0 || homeFilterStore.maxPrice > 0;
        });
        const priceRangeDisplay = computed(() => {
            const minPrice = homeFilterStore.minPrice;
            const maxPrice = homeFilterStore.maxPrice;
            if (minPrice > 0 && maxPrice > 0) {
                return `$${minPrice.toLocaleString()} - $${maxPrice.toLocaleString()}`;
            }
            if (minPrice > 0) {
                return `$${minPrice.toLocaleString()} >`;
            }
            if (maxPrice > 0) {
                return `< $${maxPrice.toLocaleString()}`;
            }
            return '';
        });
        const yearSummary = computed(() => {
            const minYear = homeFilterStore.minYear;
            const maxYear = homeFilterStore.maxYear;
            if (minYear && maxYear) {
                return `${minYear} - ${maxYear}`;
            }
            if (minYear) {
                return `From ${minYear}`;
            }
            if (maxYear) {
                return `Up to ${maxYear}`;
            }
            return '';
        });
        const hasYearFilter = computed(() => {
            return homeFilterStore.minYear || homeFilterStore.maxYear;
        });
        const yearRangeDisplay = computed(() => {
            const minYear = homeFilterStore.minYear;
            const maxYear = homeFilterStore.maxYear;
            if (minYear && maxYear) {
                return `${minYear} - ${maxYear}`;
            }
            if (minYear) {
                return `${minYear} >`;
            }
            if (maxYear) {
                return `< ${maxYear}`;
            }
            return '';
        });
        const hasSizeFilter = computed(() => {
            return homeFilterStore.minSizeDiameter > 0 || homeFilterStore.maxSizeDiameter > 0;
        });
        const sizeRangeDisplay = computed(() => {
            const min = homeFilterStore.minSizeDiameter;
            const max = homeFilterStore.maxSizeDiameter;
            if (min > 0 && max > 0) {
                return `${min} - ${max} mm`;
            }
            if (min > 0) {
                return `${min} mm >`;
            }
            if (max > 0) {
                return `< ${max} mm`;
            }
            return '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(homeFilterStore).selectedBrands.length > 0 && _unref(homeFilterStore).selectedBrands.length < 4)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(homeFilterStore).selectedBrands, (brand) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: brand.id,
                            class: "flex-none inline-flex items-center gap-2 bg-neutral text-badge px-3 py-2 rounded-[4px] text-sm font-medium"
                        }, [
                            _createElementVNode("span", null, _toDisplayString(brand.name), 1),
                            _createVNode(_unref(X), {
                                class: "size-4 cursor-pointer text-badge",
                                onClick: ($event) => (_unref(homeFilterStore).toggleBrandSelection(brand.id))
                            }, null, 8, ["onClick"])
                        ]));
                    }), 128))
                    : (_unref(homeFilterStore).selectedBrands.length >= 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("span", null, "Brand(" + _toDisplayString(_unref(homeFilterStore).selectedBrands.length) + ")", 1),
                            _createVNode(_unref(X), {
                                class: "size-4 cursor-pointer text-badge",
                                onClick: clearAllBrands
                            })
                        ]))
                        : _createCommentVNode("", true),
                (_unref(homeFilterStore).selectedConditions.length > 0 && _unref(homeFilterStore).selectedConditions.length < 4)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(homeFilterStore).selectedConditions, (condition) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: condition.id,
                            class: "flex-none inline-flex items-center gap-2 bg-neutral text-badge px-3 py-2 rounded-[4px] text-sm font-medium"
                        }, [
                            _createElementVNode("span", null, _toDisplayString(condition.name), 1),
                            _createVNode(_unref(X), {
                                class: "size-4 cursor-pointer text-badge",
                                onClick: ($event) => (_unref(homeFilterStore).toggleConditionSelection(condition.id))
                            }, null, 8, ["onClick"])
                        ]));
                    }), 128))
                    : (_unref(homeFilterStore).selectedConditions.length >= 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("span", null, "Condition(" + _toDisplayString(_unref(homeFilterStore).selectedConditions.length) + ")", 1),
                            _createVNode(_unref(X), {
                                class: "size-4 cursor-pointer text-badge",
                                onClick: clearAllConditions
                            })
                        ]))
                        : _createCommentVNode("", true),
                (hasPriceFilter.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("span", null, _toDisplayString(priceRangeDisplay.value), 1),
                        _createVNode(_unref(X), {
                            class: "size-4 cursor-pointer text-badge",
                            onClick: clearPriceFilter
                        })
                    ]))
                    : _createCommentVNode("", true),
                (hasYearFilter.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("span", null, _toDisplayString(yearRangeDisplay.value), 1),
                        _createVNode(_unref(X), {
                            class: "size-4 cursor-pointer text-badge",
                            onClick: clearYearFilter
                        })
                    ]))
                    : _createCommentVNode("", true),
                (hasSizeFilter.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(sizeRangeDisplay.value), 1),
                        _createVNode(_unref(X), {
                            class: "size-4 cursor-pointer text-badge",
                            onClick: clearSizeFilter
                        })
                    ]))
                    : _createCommentVNode("", true),
                (_unref(homeFilterStore).selectedBrands.length === 0 && _unref(homeFilterStore).selectedConditions.length === 0 && !hasPriceFilter.value && !hasYearFilter.value && !hasSizeFilter.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No filters selected "))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
